import React, { useEffect, useState } from 'react';
import './UpdateBanner.css';

const UpdateBanner = () => {
  const [showUpdate, setShowUpdate] = useState(false);

  useEffect(() => {
    // Vérifier si un service worker est enregistré
    if ('serviceWorker' in navigator) {
      let refreshing = false;

      // Écouter les mises à jour du service worker
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // Fonction pour vérifier les mises à jour
      const checkForUpdates = async () => {
        try {
          const registration = await navigator.serviceWorker.ready;
          
          // Vérifier s'il y a un service worker en attente
          if (registration.waiting) {
            setShowUpdate(true);
            return;
          }

          // Écouter les nouvelles mises à jour
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  // Il y a une nouvelle version disponible
                  setShowUpdate(true);
                }
              });
            }
          });

          // Vérifier périodiquement les mises à jour
          await registration.update();
        } catch (error) {
          console.warn('Erreur lors de la vérification des mises à jour:', error);
        }
      };

      // Vérifier immédiatement
      checkForUpdates();

      // Vérifier périodiquement (toutes les minutes)
      const interval = setInterval(checkForUpdates, 60000);

      return () => clearInterval(interval);
    }
  }, []);

  const handleUpdate = () => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then((registration) => {
        if (registration.waiting) {
          // Envoyer un message au service worker pour qu'il active la nouvelle version
          registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        // Recharger la page
        window.location.reload();
      });
    }
  };

  if (!showUpdate) return null;

  return (
    <div className="update-banner">
      <div className="update-banner-content">
        <span className="update-banner-icon">🔄</span>
        <span className="update-banner-text">
          Une nouvelle version est disponible !
        </span>
        <button className="update-banner-button" onClick={handleUpdate}>
          Mettre à jour
        </button>
      </div>
    </div>
  );
};

export default UpdateBanner;
